/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import imageModifier from '../../../../utils/imageModifier';
import GalleryContainer from '../../../Gallery/GalleryContainer';
import Modal from '../../../Modal/Modal';

import getMamObjectsBySlugName from '../../../../api/graphql/queries/getMamObjectsBySlugname';
import showObject from '../../../../utils/showObject';

const GalleryModule = ({
  activeLanguage, handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname, isCarousel, toggleRefetch,
}) => {
  const initialGalleryModuleState = {};

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialGalleryModuleState);
  const [isModalOn, setModalState] = useState(false);
  const [activeLang, setActiveLanguage] = useState('');
  const [imagesArray, setImagesArray] = useState([]);
  const [simpleImages, setSimpleImages] = useState([]);

  const toggleModal = (lang) => {
    setActiveLanguage(lang);
    setModalState(!isModalOn);
  };

  useEffect(() => {
    if (imagesArray.length && Object.keys(state).length) {
      const updtState = {
        ...state,
        objects: simpleImages,
      };
      setState(updtState);
    }
  }, [imagesArray]);

  const setGallery = async (slugName, images, shouldToggle = true, galleryData) => {
    if (shouldToggle) {
      toggleModal();
    }

    if (galleryData) {
      setState(galleryData);
    }

    if (images.length) {
      setSimpleImages(images);
    }

    const imagesArrayFromPromise = [];
    const imagesArrayQuery = await getMamObjectsBySlugName(images);
    for (const obj of imagesArrayQuery) {
      const res = await showObject(obj.assetSlugName, obj.fileExtension);
      imagesArrayFromPromise.push(res);
    }

    setImagesArray(imagesArrayFromPromise);

    if (index >= 0 && components) {
      const { component } = components[index];

      const comp = {
        ...component,
        key: slugName,
      };

      // setState(comp);
      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];

    if (reusableComponent) {
      setState(reusableComponent);
      const imagesArrayDisplay = reusableComponent.objects;
      setGallery(reusableComponentSlugname, imagesArrayDisplay, false);
      if (reusableComponentSlugname) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        setState(component);
        const slugName = component.name && component.name.toLowerCase().replace(/ /g, '-');
        const imagesArrayDisplay = component.objects;
        setGallery(slugName, imagesArrayDisplay, false);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  return (
    <>
      <div className="bg-greyFilter px-4 py-2 pl-8 flex justify-end rounded-lg">
        <button className="font-americaMonoBold text-xs pl-8 pr-6 py-2 rounded-full uppercase bg-black text-white flex items-center" type="button" onClick={() => toggleModal(activeLanguage)}>
          {isCarousel ? (imagesArray.length ? 'Modify Carousel With Description' : 'Add Carousel With Description') : imagesArray.length ? 'Modify Gallery' : 'Add Gallery'}
          {imagesArray.length ? <span className="font-icon icon-edit text-sm font-bold pl-2 text-white" /> : <span className="font-icon icon-add-button text-base font-bold pl-2 text-white" />}
        </button>
      </div>
      {imagesArray.length ? (
        <div className="flex flex-wrap p-4 w-full pl-13">
          {imagesArray.map(image => (
            <div className="bg-greyFilter rounded m-8px pb-5 w-210px h-275px flex flex-col items-center pt-4" key={image}>
              <img src={imageModifier(image, '178x178')} alt={image} />
            </div>
          ))}
        </div>
      ) : null}
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle size="w-auto">
          <GalleryContainer type="image" selectCallback={setGallery} getGalleryData={state} isCarousel={isCarousel} toggleRefetch={toggleRefetch} />
        </Modal>
      )}
    </>
  );
};

GalleryModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  reusableComponentSlugname: PropTypes.string,
  isCarousel: PropTypes.bool,
  toggleRefetch: PropTypes.func.isRequired,
};
GalleryModule.defaultProps = {
  reusableComponent: null,
  reusableComponentSlugname: '',
  isCarousel: false,
};

export default GalleryModule;
